<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.containers'), name: 'company_containers' },
            {
              text: container.name,
              name: 'company_container',
              params: { container_uuid: $route.params.container_uuid },
            },
            { text: $t('containers.addUvvCheck') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('containers.addUvvCheck') }}</h3>
            <div class="header-meta"></div>
          </header>
          <div class="content-body">
            <LoadingSpinner v-if="loading" />
            <div v-else>
              <form @submit.prevent="addUvvCheck" class="form" method="post">
                <div class="form-wrap">
                  <label for="performed_at">{{ $t('containers.uvvCheckPerformedAt') }}</label>
                  <input
                    v-model="uvvCheck.performed_at"
                    class="form-input"
                    type="date"
                    name="performed_at"
                    id="performed_at"
                  />
                </div>

                <div class="form-wrap">
                  <label for="date">{{ $t('containers.nextUvvCheck') }}</label>
                  <input v-model="uvvCheck.date" class="form-input" type="date" name="date" id="date" />
                </div>

                <div class="form-wrap">
                  <label for="badge">{{ $t('containers.uvvCheckBadge') }}</label>
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    @change="event => setAttachment('badge', event)"
                    id="badge"
                  />
                </div>

                <div class="form-wrap">
                  <label for="doc">{{ $t('containers.uvvCheckReport') }}</label>
                  <input type="file" accept="image/*,.pdf" @change="event => setAttachment('doc', event)" id="doc" />
                </div>

                <p style="margin-bottom: 0">
                  <input type="submit" :value="$t('meta.save')" class="button button-green button-100 button-round" />
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import containersApi from '@/api/container'

export default {
  name: 'company_container_type',
  data() {
    return {
      loading: true,
      container: {},
      errors: [],
      uvvCheck: {
        date: new Date(),
        badge: '',
        doc: '',
      },
    }
  },
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SectionHeader,
  },
  methods: {
    addUvvCheck: async function () {
      const formData = new FormData()
      formData.append('date', this.uvvCheck.date)
      formData.append('performed_at', this.uvvCheck.performed_at)
      if (this.uvvCheck.badge) {
        formData.append('badge', this.uvvCheck.badge)
      }
      if (this.uvvCheck.doc) {
        formData.append('doc', this.uvvCheck.doc)
      }

      const response = await containersApi.createUvvCheck(this.$route.params.container_uuid, formData)
      if (response.success) {
        await this.$router.push(`/company/containers/${this.$route.params.container_uuid}`)
      } else {
        this.errors = response.errors
      }
    },
    setAttachment(type, event) {
      this.uvvCheck[type] = event.target.files[0]
    },
  },
  async mounted() {
    this.container = await containersApi.get(this.$route.params.container_uuid)
    this.loading = false
  },
}
</script>
